import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/692e6e6b5a2410001474a297_1787653183712_276ea926/yunova_international/src/app/destinations/[id]/page.tsx");
